import type { FC } from 'react';
import { Link } from 'react-router-dom';

import {
  FeatureFilterField,
  FeatureName,
  UserFilterValues,
} from '__generated__/GQL';
import useCanCompanyUserAccessFeature from 'common/hooks/useCanCompanyUserAccessFeature';
import Button from 'components/_core/Button';
import * as routes from 'features/PaymentCards/routes';
import * as Layout from 'layouts/ContentLayout';

import locales from './locales';

export const NewPaymentCardList: FC = () => {
  const { canAccessFeature } = useCanCompanyUserAccessFeature();

  const canRequestPaymentCards = canAccessFeature({
    name: FeatureName.RequestPaymentcards,
    where: {
      or: [{ field: FeatureFilterField.User, values: [UserFilterValues.Self] }],
    },
  });
  const canOrderPaymentCards = canAccessFeature({
    name: FeatureName.PaymentcardsOrder,
  });

  const shouldDisplayAction = canOrderPaymentCards || canRequestPaymentCards;

  return (
    <Layout.Root>
      <Layout.Body size="md">
        <Layout.Header
          action={
            shouldDisplayAction ? (
              <Button
                as={Link}
                icon="plus"
                iconPosition="left"
                to={canOrderPaymentCards ? routes.orderNew : routes.requestNew}
                variant="secondary"
              >
                {canOrderPaymentCards
                  ? locales.orderNewCard
                  : locales.requestNewCard}
              </Button>
            ) : null
          }
          title={locales.title}
        />
      </Layout.Body>
    </Layout.Root>
  );
};
